import React, { useState } from 'react';
import { useEffect } from 'react';
import { Table, Form } from 'react-bootstrap';
import { handleEdit, handleGetSize_list } from './editablePriceTableModel';

const EditablePriceTable = ({data,sizeData,setSizeData}) => {   
  const [loading, setLoading] = useState([]);
  const [filter, setFilter] = useState({action:'product_size',subid:data?.subid});

  useEffect(() => {
    handleGetSize_list({setSizeData,filter,setLoading,pid:data?.id})
  },[])
     

  const cellStyle = {
    padding: '2px 6px',
    fontSize: '13px',
    verticalAlign: 'middle',
  };

  const inputStyle = {
    padding: '2px 6px',
    fontSize: '13px',
    height: '28px',
    textAlign: 'center',
  };

  return (
    <>    
    {loading === true ? (
       <>    
       <div className='d-flex justify-content-center'>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Loading...
        </div>
        </>
    ):(
    <>      
    <Table bordered size="sm" className="mb-0" style={{ tableLayout: 'fixed', width: '100%' }}>
      <thead>
        <tr className="text-center">
          <th style={{ ...cellStyle, width: '50%' }}>Size</th>
          <th style={{ ...cellStyle, width: '25%' }}>MRP</th>
          <th style={{ ...cellStyle, width: '25%' }}>Price</th>
        </tr>
      </thead>
      <tbody>
        {sizeData.map((row, idx) => (
          <tr key={idx} className="text-center">
            <td style={{ ...cellStyle, width: '50%',textAlign:'left' }}>{row.sizename}</td>
            <td style={{ ...cellStyle, width: '25%' }}>
              <Form.Control
                className="text-end"
                type="number"
                size="sm"
                style={inputStyle}
                value={row.ch_mrp}
                onChange={(e) => handleEdit(idx, 'ch_mrp', e.target.value,sizeData,setSizeData)}
              />
            </td>
            <td style={{ ...cellStyle, width: '25%' }}>
              <Form.Control
                className="text-end"
                type="number"
                size="sm"
                style={inputStyle}
                value={row.ch_price}
                onChange={(e) => handleEdit(idx, 'ch_price', e.target.value,sizeData,setSizeData)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
    </>)
    }
  </>
  );
};

export default EditablePriceTable;
